import { render, staticRenderFns } from "./temporary.vue?vue&type=template&id=0bcf64a4&scoped=true&"
import script from "./temporary.vue?vue&type=script&lang=js&"
export * from "./temporary.vue?vue&type=script&lang=js&"
import style0 from "./temporary.vue?vue&type=style&index=0&id=0bcf64a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcf64a4",
  null
  
)

export default component.exports